module.exports = __webpack_public_path__ + "media/images/avoid-duplicate-b59b69406795e5bf4894ebdb499c518e.svg";